import { render, staticRenderFns } from "./SliceCategoryHeading.vue?vue&type=template&id=49583e6c&lang=pug&"
import script from "./SliceCategoryHeading.vue?vue&type=script&lang=js&"
export * from "./SliceCategoryHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports